<template>
    <RouterView />
    <CookieNotice />
</template>

<script>
import CookieNotice from '@/shared/components/cookie-notice/CookieNotice.vue';

export default {
    name: 'App',
    components: { CookieNotice },
};
</script>

<style>
@import "@/assets/css/reset.css";
@import "@/assets/css/init.css";
</style>
